var _excluded = ["children", "className"];

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from "react";
import cx from "clsx";
var defaultProps = {
  className: "react-tabs__tab-list"
};

var TabList = function TabList(props) {
  var children = props.children,
      className = props.className,
      attributes = _objectWithoutPropertiesLoose(props, _excluded);

  return React.createElement("ul", Object.assign({}, attributes, {
    className: cx(className),
    role: "tablist"
  }), children);
};

TabList.tabsRole = "TabList";
TabList.defaultProps = defaultProps;
export default TabList;